export default __webpack_public_path__ + "static/media/small.a5900868.jpg";